module.exports = __webpack_public_path__ + "static/img/hdw14.163ab80b.jpg";